/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate a daily water target from your body weight and exercise. The calculator uses about 35 ml per kilogram plus extra for time spent exercising.`)
};

const es_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima un objetivo diario de agua según tu peso corporal y ejercicio. La calculadora usa unos 35 ml por kilogramo más un extra por el tiempo dedicado a hacer ejercicio.`)
};

const de_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätze ein tägliches Trinkziel anhand deines Körpergewichts und deines Trainings. Der Rechner verwendet etwa 35 ml pro Kilogramm plus einen Zuschlag für die Trainingszeit.`)
};

const nl_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat een dagelijks waterdoel op basis van je lichaamsgewicht en beweging. De calculator gaat uit van ongeveer 35 ml per kilogram plus extra voor de tijd die je sport.`)
};

const fr_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez un objectif quotidien d'eau à partir de votre poids corporel et de votre exercice. Le calculateur utilise environ 35 ml par kilogramme plus un supplément pour le temps passé à faire de l'exercice.`)
};

const it_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima un obiettivo giornaliero di acqua dal tuo peso corporeo e dall'esercizio fisico. Il calcolatore usa circa 35 ml per chilogrammo più un extra per il tempo dedicato all'esercizio.`)
};

const pt_br2_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime uma meta diária de água a partir do seu peso corporal e exercício. A calculadora usa cerca de 35 ml por quilo, mais um extra pelo tempo dedicado a exercícios.`)
};

const pt_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime um objetivo diário de água a partir do seu peso corporal e exercício. A calculadora usa cerca de 35 ml por quilograma, mais um extra pelo tempo de exercício.`)
};

const ja_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体重と運動量から1日の水分目標量を推定します。この計算機は体重1kgあたり約35mlに、運動時間分の追加量を加算します。`)
};

const zh_water_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据你的体重和运动量估算每日饮水目标。计算器按每千克体重约 35 毫升，再加上运动时间对应的额外摄入量进行估算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_intro", locale)
	if (locale === "en") return en_water_intro(inputs)
	if (locale === "es") return es_water_intro(inputs)
	if (locale === "de") return de_water_intro(inputs)
	if (locale === "nl") return nl_water_intro(inputs)
	if (locale === "fr") return fr_water_intro(inputs)
	if (locale === "it") return it_water_intro(inputs)
	if (locale === "pt-BR") return pt_br2_water_intro(inputs)
	if (locale === "pt") return pt_water_intro(inputs)
	if (locale === "ja") return ja_water_intro(inputs)
	return zh_water_intro(inputs)
};